import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-receivables-imports-row-details',
  templateUrl: './receivables-imports-row-details.component.html',
  styleUrls: ['./receivables-imports-row-details.component.scss']
})
export class ReceivablesImportsRowDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  receivablesImportRowId: string;
  receivablesImportRowObject?: ReceivablesImportRow;
  receivablesImportRow: ReplaySubject<ReceivablesImportRow> = new ReplaySubject<ReceivablesImportRow>(1);
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private receivablesImportsRow: ReceivablesImportsRowService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.receivablesImportRowId = params.id;
        this.loadReceivablesImportsRow();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadReceivablesImportsRow(): void {
    this.receivablesImportsRow.get(this.receivablesImportRowId).subscribe((receivablesImportsRow: ReceivablesImportRow) => {
      this.receivablesImportRow.next(receivablesImportsRow);
      this.receivablesImportRowObject = receivablesImportsRow;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
